/**
 * What the student has ticked, and what the API will be sent.
 *
 * Nothing is ticked by default. The whole point of the review step is that a
 * machine's reading of a PDF does not land on a profile unless a person put a
 * tick against it, and pre-ticking the boxes would quietly undo that.
 */

export const EMPTY_SELECTION = {
  skills: [],
  education: [],
  experience: [],
  certifications: [],
  projects: [],
  headline: false,
  links: false,
};

/** Toggle one value in one of the list fields. */
export function toggle(selection, field, value) {
  const current = selection[field];
  return {
    ...selection,
    [field]: current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value],
  };
}

/**
 * Items a student can act on: everything they do not already have, and that
 * we read enough of to save.
 */
export function selectable(items) {
  return items.filter((item) => item.is_complete && !item.already_on_profile);
}

export function selectableSkills(skills) {
  return skills.filter((skill) => !skill.already_on_profile);
}

/** How many suggestions are left to do something about. */
export function outstanding(parse) {
  if (!parse || parse.status !== 'READY') return 0;
  return (
    selectableSkills(parse.skills).length +
    selectable(parse.education).length +
    selectable(parse.experience).length +
    selectable(parse.certifications).length +
    selectable(parse.projects ?? []).length +
    (parse.headline_available ? 1 : 0) +
    (parse.contact.linkedin_available ||
    parse.contact.github_available ||
    parse.contact.portfolio_available
      ? 1
      : 0)
  );
}

export function count(selection) {
  return (
    selection.skills.length +
    selection.education.length +
    selection.experience.length +
    selection.certifications.length +
    selection.projects.length +
    (selection.headline ? 1 : 0) +
    (selection.links ? 1 : 0)
  );
}

/** Tick everything that can be ticked, for the "select all" affordance. */
export function selectAll(parse) {
  return {
    skills: selectableSkills(parse.skills).map((skill) => skill.name),
    education: selectable(parse.education).map((item) => item.index),
    experience: selectable(parse.experience).map((item) => item.index),
    certifications: selectable(parse.certifications).map((item) => item.index),
    projects: selectable(parse.projects ?? []).map((item) => item.index),
    headline: parse.headline_available,
    links:
      parse.contact.linkedin_available ||
      parse.contact.github_available ||
      parse.contact.portfolio_available,
  };
}
